module.exports = __webpack_public_path__ + "img/SOWEE_120X35.04e0c5a0.png";